import { configureStore } from "@reduxjs/toolkit";
import userReducer from "./reducers/userSlice";
import vmReducer from "./reducers/vmSlice";
import adminReducer from "./reducers/adminSlice";
export const store = configureStore({
    reducer: {
        virtualMachine : vmReducer,
        user: userReducer,
        adminPanel: adminReducer,
    },
})

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch